export default "__VITE_ASSET__D9W519lv__"